import { earliestTextSendTime, lastTextSendTime } from "@santa/common/lib/products/texts";
import { Field } from "formik";
import styled from "styled-components";
import { Row, Col } from "react-grid-system";

import { ContentPanel } from "../../../atoms/content-panel";
import { Heading3 } from "../../../atoms/text";
import { FormFieldWrapper } from "../../form-field-wrapper";
import { FormikFormInputDate } from "../../../molecules/form/form-input-date";
import { FormikFormInputTextarea } from "../../../molecules/form/form-input-textarea";
import { FormFieldMessageTime } from "../../../molecules/form/form-fields/form-field-message-time";
import { config } from "../../../../config";

const MessagePanel = styled(ContentPanel)`
  > h3 {
    :first-child {
      margin-top: 0;
      font-weight: normal;
    }
  }

  margin-left: -14px;
  margin-right: -14px;
  margin-bottom: 10px;

  :last-child {
    margin-bottom: -9px;
  }
`;

interface IProps {
  message: number;
}

export const TextDetailsMessagesMessageForm: React.FC<IProps> = ({ message }) => {
  const ordinal = ((i: number): string => {
    switch (i) {
      case 1:
        return "First";
      case 2:
        return "Second";
      case 3:
        return "Third";
      default:
        throw new Error("Unexpected index");
    }
  })(message);

  return (
    <MessagePanel colour="yellow">
      <Heading3>{ordinal} Message</Heading3>
      <Row>
        <Col xl={6}>
          <FormFieldWrapper
            label="Date to send message?"
            name={`text${message}TimeDate`}
            required
            noLabel
          >
            <Field
              name={`text${message}TimeDate`}
              component={FormikFormInputDate}
              placeholder="Select a date"
              minDate={earliestTextSendTime()}
              maxDate={lastTextSendTime()}
              dateFormat="MMMM dd, yyyy"
            />
          </FormFieldWrapper>
        </Col>
        <Col xl={6}>
          <FormFieldMessageTime id={`text${message}TimeTime`} />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormFieldWrapper label="Message to send" name={`text${message}Body`} required>
            <Field
              name={`text${message}Body`}
              component={FormikFormInputTextarea}
              placeholder="Type your message here"
              maxLength={config.texts.messageMaxLength}
              rows={4}
            />
          </FormFieldWrapper>
        </Col>
      </Row>
    </MessagePanel>
  );
};
